<template>
  <el-dialog
    :visible="visible"
    width="400px"
    title="设备删除"
    @closed="reset"
    @close="handleCancle"
  >
    <div class="result-box">
      <img src="@/assets/images/warning.png" alt="" />
      <span>是否删除设备</span>
    </div>
    <el-row slot="footer" class="dialog-footer">
      <el-button @click="handleCancle">取消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="btnLoading">确定</el-button>
    </el-row>
  </el-dialog>
</template>
<script>
import deviceApi from '@/api/home/device.js';

export default {
  data() {
    return {
      idList: [],
      visible: false,
      btnLoading: false
    };
  },
  methods: {
    init(data) {
      this.visible = true;
      this.idList = data;
    },
    reset() {
      this.idList = [];
    },
    handleCancle() {
      this.visible = false;
      this.btnLoading = false;
    },
    handleSubmit() {
      this.btnLoading = true;
      deviceApi
        .delDevice({ deviceIdList: this.idList })
        .then(res => {
          if (res.data.code !== 200) {
            this.$message.error('删除失败');
            return;
          }
          this.$message.success('删除设备成功！');
          this.$emit('back');
        })
        .finally(() => {
          this.visible = false;
          this.btnLoading = false;
        });
    }
  }
};
</script>
<style lang="less" scoped>
.result-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  img {
    width: 50px;
  }
  span {
    margin-top: 20px;
    font-size: 24px;
  }
}
</style>